/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Sports11Inputs */

const en__field_enum_icsrm_sports11 = /** @type {(inputs: _Field_Enum_Icsrm_Sports11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sports & Fitness`)
};

const de__field_enum_icsrm_sports11 = /** @type {(inputs: _Field_Enum_Icsrm_Sports11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sport & Fitness`)
};

/**
* | output |
* | --- |
* | "Sports & Fitness" |
*
* @param {_Field_Enum_Icsrm_Sports11Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_sports11 = /** @type {((inputs?: _Field_Enum_Icsrm_Sports11Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Sports11Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_sports11(inputs)
	return de__field_enum_icsrm_sports11(inputs)
});
export { _field_enum_icsrm_sports11 as "_field_enum_ICSRM_SPORTS" }